import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import logo from "assets/images/comedor.png";

// Header alternativo para PDFs de eventos/presupuesto
// - Logo + nombre a la izquierda
// - Texto a la derecha: CUIT y Dirección
// - Línea inferior con color institucional
const PdfHeaderEventos = () => {
  return (
    <Grid
      container
      pb={2}
      mb={2}
      mt={0}
      pt={1}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        borderBottom: 2,
        borderColor: "rgba(222, 0, 118)",
      }}
    >
      {/* Izquierda: logo + texto */}
      <Grid item xs={5} display="flex" alignItems="center" gap={2}>
        <img src={logo} alt="UPrO" style={{ width: 56, height: "auto" }} />
        <SoftBox lineHeight={1}>
          <SoftTypography variant="h6" fontWeight="bold">Fundación</SoftTypography>
          <SoftTypography variant="h6" fontWeight="bold">UPrO</SoftTypography>
        </SoftBox>
      </Grid>

      {/* Derecha: cuit + dirección */}
      <Grid item xs={7} display="flex" flexDirection="column" alignItems="end" justifyContent="right">
        <SoftTypography variant="body2" sx={{ color: "rgba(222, 0, 118)", fontWeight: 500 }}>
          CUIT: 30-71886198-1
        </SoftTypography>
        <SoftTypography variant="body2" sx={{ color: "rgba(222, 0, 118)", fontWeight: 500 }}>
          Dirección: 9 DE JULIO 1095– Villa Mercedes (SL)
        </SoftTypography>
      </Grid>
    </Grid>
  );
};

export default PdfHeaderEventos;
